/**
 * 路由创建器
 * 负责将纯配置转换为 React Router 路由
 */
import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import { MainLayout } from "@ms/shared-components";
import { AuthGuard } from "@ms/shared-auth";

// 导入页面组件
import ServicesPage from "../pages/services";
import AdminsPage from "../pages/admins";
import RolesPage from "../pages/roles";
import OperationsPage from "../pages/operations";
import AssignmentPage from "../pages/assignment";
import UsageDocsPage from "../pages/usageDocs";
import ApiDocsPage from "../pages/apiDocs";

// 导入权限检查组件
// import PermissionDebugTool from "../components/PermissionDebugTool";

// 导入路由配置
import { ROUTE_CONFIG, RouteConfigItem, getMenuItems, getBreadcrumbConfig } from "./routeConfig";

// 组件映射
const COMPONENT_MAP = {
  ServicesPage,
  AdminsPage,
  RolesPage,
  OperationsPage,
  AssignmentPage,
  UsageDocsPage,
  ApiDocsPage,
} as const;

/**
 * 创建路由配置
 * @param layoutConfig 布局配置
 * @param currentPath 当前路径
 * @param navigate 导航函数
 * @returns 路由配置数组
 */
export const createRouteConfig = (
  layoutConfig: any,
  currentPath: string,
  navigate: (path: string) => void
): RouteObject[] => {
  // 更新布局配置，添加菜单项和面包屑
  const updatedLayoutConfig = {
    ...layoutConfig,
    menuItems: getMenuItems(navigate),
    breadcrumbs: getBreadcrumbConfig(currentPath),
  };
  return ROUTE_CONFIG.map((route: RouteConfigItem): RouteObject => {
    // 处理根路径重定向 - 重定向到微服务管理页面（msadmin的主要功能）
    if (route.path === "/") {
      return {
        path: "/",
        element: React.createElement(Navigate as any, {
          to: "/services",
          replace: true,
        }),
      };
    }

    // 获取页面组件
    const PageComponent = COMPONENT_MAP[route.component as keyof typeof COMPONENT_MAP];

    if (!PageComponent) {
      throw new Error(`未找到组件: ${route.component}`);
    }

    // 创建带权限保护的路由
    return {
      path: route.path,
      element: React.createElement(AuthGuard as any, {
        requiredPermissions: route.requiredPermissions,
        children: React.createElement(MainLayout as any, {
          config: updatedLayoutConfig,
          currentPath: currentPath,
          children: React.createElement(PageComponent as any),
        }),
      }),
    };
  });
};
